export const USERS_GET_ALL = 'USERS_GET_ALL'
export const SET_SELECTED_USER = 'SET_SELECTED_USER'
export const USER_TYPES_GET_ALL = 'USER_TYPES_GET_ALL'
export const PERMISSIONS_GET_ALL = 'PERMISSIONS_GET_ALL'
export const ADD_USER = 'ADD_USER'
export const UPDATE_USER = 'UPDATE_USER'



// WEBPACK FOOTER //
// ./src/store/modules/users/mutation-types.js